import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import classnames from 'classnames';
import { useNeuroState, NeuroMessage, useDispatch, usePages } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';

const HeaderMenu = ({ className, showMenu, setShowMenu, currentPage }) => {
  const { goToSpecificPage } = usePages();
  const { user } = useNeuroState();
  const employee = user?.assignment?.employee;
  const branch = user?.assignment?.branch;
  const classes = classnames(className, 'header-menu-modal');
  const closeBtn = <ReactSVG src="/classpath/assets/images/icons/icon-close-menu.svg" />;
  const dispatch = useDispatch();

  const onBackToBeginningClick = () => {
    let url = `/guide/spa/${user.uuid}/entry/bankingRelationship-page`;
    goToSpecificPage(url);
    setShowMenu(false);
  }

  return (
    <>
      <Modal
        className={classes}
        show={showMenu}
        onClose={() => setShowMenu(false)}
        closeBtn={closeBtn}
        nodeId="root">
        <div className="info-container">
          <div className="user-info">
            { employee && <h1 className="user-info__name">{`${employee.firstName} ${employee.lastName}`}</h1> }
            { branch && <h2 className="user-info__branch">{branch.name}</h2>}
          </div>
          { !currentPage.includes("lookup-page") &&
            <div className="menu-actions">
              <button className="go-to-beginning" onClick={onBackToBeginningClick}>
                <ReactSVG src="/classpath/assets/images/icons/icon-begin.svg" />
                <NeuroMessage id="header.menu.goToBeginning" tagName="span" />
              </button>
            </div>
          }
        </div>
        <div className="iso-commerce">
          <ReactSVG src="/classpath/assets/images/iso-commerce.svg" />
        </div>
      </Modal>
    </>
  );
}

HeaderMenu.propTypes = {
  className: PropTypes.string,
  showMenu: PropTypes.bool,
  setShowMenu: PropTypes.func
};


export default HeaderMenu;